import { render, staticRenderFns } from "./ProjectPageManagerTile.vue?vue&type=template&id=b53cf192"
import script from "./ProjectPageManagerTile.vue?vue&type=script&lang=js"
export * from "./ProjectPageManagerTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports